import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(public auth: AuthenticationService, private router: Router) {}
 
  canActivate() {
    return this.auth.authenticationState.pipe(
      switchMap(isAuthenticated => {
        if (isAuthenticated) {
          return of(true);
        }
        else {
          return this.auth.checkAuthentication()
          .pipe(
            catchError(val => of(false)),
            take(1),
            map(user => {
              if (!!user) {
                this.auth.authenticationState.next(true);
                return true;
              }
              else {
                return false;
              }
            })  
          )
        }
      }),
      map(isAuthenticated => {
        if (! isAuthenticated) {
          return this.router.parseUrl('/login');
        }
        else {
          return isAuthenticated;
        }
      })
    );
  }
}
